import { PureComponent } from 'react'
import cx from 'classnames'
import { is } from 'immutable'
import DropZone from 'react-dropzone'
import Button from 'shared-web/src/components/Button'
import { Layout } from 'app/modules/profile/constants'
import { Subsection, Row } from 'components/settings/UserProfile/Section'
import FakeBrowser from './FakeBrowser'
import { CardLayoutPreview, WideLayoutPreview } from './ProfileLayoutPreview'
import styles from './styles.styl'

const ProfileLayoutInput = ({
  value,
  onChange,
  checked = false,
  children,
}) => (
  <label
    className={cx(styles.ProfileLayoutInput, {
      [styles['ProfileLayoutInput--checked']]: checked,
    })}
  >
    <input
      className={styles.ProfileLayoutInput__radio}
      type="radio"
      name="profile-layout-choice"
      value={value}
      onChange={onChange}
      checked={checked}
    />
    {children}
  </label>
)

class ThemeInfo extends PureComponent {
  handleLayoutChange = (event) => {
    this.props.actions.setProfileUIData({
      key: 'layout',
      value: event.currentTarget.value,
    })
  }

  handleSave = () => {
    if (!this.canSubmit() || !this.isValid()) return
    this.props.actions.updateTheme()
  }

  handleCancel = () => {
    this.props.actions.setProfileUI(this.props.theme)
  }

  handleCoverPhotoUploadClick = () => {
    this._dropZoneRef.open()
  }

  handleClearCoverPhotoClick = () => {
    this.props.actions.setProfileUIData({
      key: 'coverPhotoUrl',
      value: '',
    })
    return false
  }

  handleCoverPhotoChange = (files) => {
    const file = files[0]
    this.props.actions.uploadCoverPhoto(file)
  }

  canSubmit() {
    return !is(this.props.theme, this.props.themeUI)
  }

  getIsUploadPending() {
    return this.props.coverPhotoUpload.get('pending')
  }

  isValid() {
    const notUploading = !this.getIsUploadPending()
    const layoutIsValid =
      this.props.themeUI.layout === Layout.CARD || (
        this.props.themeUI.layout === Layout.WIDE &&
          !!this.props.themeUI.coverPhotoUrl
      )
    return notUploading && layoutIsValid
  }

  render() {
    const {
      themeUI,
      user,
    } = this.props
    return (
      <Subsection
        title="Theme"
        isValid={this.isValid()}
        canSubmit={this.canSubmit()}
        onSubmit={this.handleSave}
        onCancel={this.handleCancel}
      >
        <div className={cx('profile-settings', styles.ThemeSettings)}>
          <Row>
            <ul style={{
              listStyleType: 'none',
              display: 'flex',
              flexFlow: 'row wrap',
              margin: 0,
              padding: 0,
              flex: '3 1 auto',
              minWidth: 0,
              minHeight: 0,
            }}>
              <li>
                <ProfileLayoutInput
                  value={Layout.CARD}
                  checked={themeUI.layout === Layout.CARD}
                  onChange={this.handleLayoutChange}
                >
                  <FakeBrowser>
                    <CardLayoutPreview user={user}/>
                  </FakeBrowser>
                </ProfileLayoutInput>
              </li>
              <li>
                <DropZone
                  className={styles.DropZone}
                  ref={c => { this._dropZoneRef = c }}
                  activeClassName={styles['DropZone--active']}
                  disableClick
                  onDrop={this.handleCoverPhotoChange}
                  multiple={false}
                >
                  <ProfileLayoutInput
                    value={Layout.WIDE}
                    checked={themeUI.layout === Layout.WIDE}
                    onChange={this.handleLayoutChange}
                    invalid={!!themeUI.coverPhotoUrl}
                  >
                    <FakeBrowser>
                      <WideLayoutPreview coverPhotoUrl={themeUI.coverPhotoUrl}/>
                    </FakeBrowser>
                  </ProfileLayoutInput>
                </DropZone>
              </li>
            </ul>

            <div style={{
              minWidth: 200,
              maxWidth: 300,
            }}>
              {themeUI.layout === Layout.WIDE && (
                <div>
                  <p className="dsg-Body color-navy-dark">
                    Upload a high-resolution profile photo to use this <b>2-column</b> theme. Your photo should be at least 800px tall.
                  </p>
                  {(themeUI.coverPhotoUrl ? (
                    <div>
                      <a onClick={this.handleClearCoverPhotoClick}>Clear Photo</a>
                    </div>
                  ) : (
                    <Button
                      className={styles.CoverPhotoUploadButton}
                      onClick={this.handleCoverPhotoUploadClick}
                    >
                      Upload photo
                    </Button>
                  ))}
                </div>
              )}
            </div>
          </Row>
        </div>
      </Subsection>
    )
  }
}

export default ThemeInfo



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ThemeInfo/index.js